import { API } from "../../api";
export async function update_basket_voucher(request) {
    const baseUrl = process.env.LETS_TRADE_BASKET_URL ?? "";
    return (await new API().apiPut({
        baseUrl,
        endpoint: `v2/update/basket/voucher`,
        content: request,
    }));
}
